import { pageHeaderStyles } from "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingHeader";
import { GridOffset } from "@insite/mobius/GridContainer";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import { COLORS } from "@store/theme/common/design";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";

Object.assign(pageHeaderStyles, {
    container: {
        gap: 0,
        css: css`
            ${GridOffset} {
                width: 100% !important;
            }
        `,
    },
    gridItem: {
        width: 12,
        css: css`
            align-items: center;
            padding: 0 0 20px;
            border-bottom: 1px solid ${COLORS.border.base};
            margin-bottom: 20px;
        `,
    },
    heading: {
        variant: "h1",
        css: css`
            margin-bottom: 0;
            padding-right: 40px;
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: ["26px", null, "48px", null, null], properties: ["font-size"] }],
                    mediaOptions.min,
                )}
        `,
    },
});
